import { verifyPayment } from "../../redux/slices/paymentSlice";
import { fetchWalletData } from "../../redux/slices/walletSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";

export const useInitializeRazorpay = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const initializeRazorpay = async (orderId, orderAmount, id,balance) => {
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: orderAmount * 100, // Convert to paise
      currency: "INR",
      name: "Lottery",
      description: "Add Money to Wallet",
      order_id: orderId,
      handler: async function (response) {
        try {
          // Dispatch verifyPayment action
          await dispatch(verifyPayment({response,balance})).unwrap();
         
          toast.success(t("wallet.success.moneyAdded"));
          dispatch(fetchWalletData(id)); // Fetch updated wallet data
        } catch (error) {
          console.error("Payment verification failed:", error);
          toast.error(t("wallet.errors.paymentVerificationFailed"));
        }
      },
      prefill: {
        name: "User Name",
        email: "user@example.com",
        contact: "9999999999",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", function () {
      toast.error(t("wallet.errors.paymentFailed"));
    });
    rzp.open();
  };

  return initializeRazorpay;
};
